<template>
  <Box theme="box-primary" title="Tổng quan đơn hàng">
    <div v-if="!loading" slot="content">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row">
          <div class="w-25 text-bold">Ngày tạo</div>
          <div class="mt-1">{{orderDetail.created_date | format_date}}</div>
        </div><div class="d-flex flex-row">
          <div class="w-25 text-bold">SĐT</div>
          <div class="mt-1"><span class="tel" @click="callPhone(orderDetail.customer.phone)">{{orderDetail.customer.phone}}</span><br></div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Khách hàng</div>
          <div class="mt-1">{{orderDetail.customer ? orderDetail.customer.name : ''}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Sản phẩm</div>
          <div class="mt-1">{{orderDetail.product ? orderDetail.product.name : ''}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Phân loại Data</div>
          <div class="mt-1">{{orderDetail.data_source ? orderDetail.data_source.name : ''}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Phân loại nguồn Data</div>
          <div class="mt-1">{{orderDetail.data_channel ? orderDetail.data_channel.name : ''}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Trạng thái</div>
          <div class="mt-1">{{orderDetail.data_status.name}}</div>
          <div class="mt-1">{{orderDetail.data_sub_status ? orderDetail.data_sub_status.name : ''}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Công nợ</div>
          <div class="mt-1">{{orderDetail.debt | format_currency}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Mã vận chuyển</div>
          <div class="mt-1">{{orderDetail.shipping_code}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Phí vận chuyển</div>
          <div class="mt-1">{{orderDetail.shipping_fee | format_currency}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Công nợ định kỳ</div>
          <div class="mt-1">{{orderDetail.annual_debt | format_currency}}</div>
        </div>
        <div class="d-flex flex-row">
          <div class="w-25 text-bold mt-1">Ngày thanh toán công nợ</div>
          <div class="mt-1">{{orderDetail.annual_due_date}}</div>
        </div>
      </div>
    </div>
    <div v-else class="text-center my-2 mt-5 mb-5" slot="content">
      <b-spinner class="align-middle"></b-spinner>
      <strong>Đang tải...</strong>
    </div>
  </Box>
</template>

<script>
import Box from '../../components/Box'
import {mapActions} from 'vuex'
import OrderApi from '../../api/orderApi'
import Utils from '../../common/utils'

export default {
  name: 'OrderGeneral',
  components: {
    Box
  },
  props: {
    orderId: {
      type: Number,
      required: true,
    }
  },
  data () {
    return {
      loading: true,
      orderDetail: null
    }
  },
  mounted () {
    this.getOrderDetail()
  },
  methods: {
    ...mapActions([
      'changePhoneNumber'
    ]),
    async getOrderDetail () {
      const id = this.$route.params.id
      this.loading = true
      if (id) {
        try {
          const orderDetail = (await OrderApi.get(id)).data.data
          this.orderDetail = {...orderDetail}
          this.loading = false
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
    },
    callPhone (phoneNumber) {
      this.changePhoneNumber({phoneNumber: phoneNumber})
      this.$bvModal.show('phone-call-modal')
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderGeneral.vue